import { useState } from "react";
import LoadingIndicator from "@components/Loading";
import { JobRow } from "./JobRow";
import { useNavigate } from "react-router-dom";
import type { JobListItem } from "@models/Job";
import { Box, Text, Divider, VStack, StackDivider, Button, HStack } from "@chakra-ui/react";

// TODO: Phase 5 - Import routes from routes.ts
const routes = {
	jobById: "/uppdrag/:id",
};

interface Props {
	isLoading: boolean;
	jobData?:
		| { totalCount: number; onGoing: JobListItem[]; past: JobListItem[]; upComing: JobListItem[] }
		| { totalCount: number; jobs: JobListItem[] };
}

const PAGE_SIZE = 10;

const JobListData = ({ isLoading, jobData }: Props) => {
	const navigate = useNavigate();

	const [onGoingPage, setOnGoingPage] = useState(1);
	const [upComingPage, setUpComingPage] = useState(1);
	const [pastPage, setPastPage] = useState(1);

	const getJobList = (type: "onGoing" | "past" | "upComing"): JobListItem[] => {
		let jobList: JobListItem[] = [];
		if (type === "onGoing") {
			const toBeViewedLength = PAGE_SIZE * onGoingPage;
			// @ts-ignore
			const data = jobData?.onGoing || [];
			if (toBeViewedLength > data.length) jobList = data;
			else {
				jobList = data.slice(0, toBeViewedLength);
			}
		}
		if (type === "past") {
			const toBeViewedLength = PAGE_SIZE * pastPage;
			// @ts-ignore
			const data = jobData?.past || [];
			if (toBeViewedLength > data.length) jobList = data;
			else {
				jobList = data.slice(0, toBeViewedLength);
			}
		}
		if (type === "upComing") {
			const toBeViewedLength = PAGE_SIZE * upComingPage;
			// @ts-ignore
			const data = jobData?.upComing || [];
			if (toBeViewedLength > data.length) jobList = data;
			else {
				jobList = data.slice(0, toBeViewedLength);
			}
		}
		return jobList;
	};

	return (
		<>
			{/* Ongoing */}
			<Box width={"100%"} mt={2}>
				<Text fontSize={"20px"} fontWeight={600}>
					Pågående uppdrag
				</Text>
				<Divider mb={2} />
				{isLoading && <LoadingIndicator size={"s"} />}
				{!isLoading && (
					<VStack divider={<StackDivider borderColor="gray.200" />} gap={2}>
						{/* @ts-ignore */}
						{getJobList("onGoing").map((job: any) => (
							<JobRow key={job.id} job={job} onClick={() => navigate(routes.jobById.replace(":id", job.id))} />
						))}
					</VStack>
				)}
				{/* @ts-ignore */}
				{!isLoading && jobData?.onGoing?.length === 0 && (
					<Text fontSize={"16px"} m={0} fontWeight={400}>
						Inga resultat att visa
					</Text>
				)}
				{/* @ts-ignore */}
				{!isLoading && jobData?.onGoing?.length > 0 && PAGE_SIZE * onGoingPage < jobData?.onGoing?.length && (
					<HStack justifyContent={"center"}>
						<Button
							onClick={() => setOnGoingPage((prev) => prev + 1)}
							colorScheme="telegram"
							variant="outline"
							size="sm"
							my={5}
						>
							Visa mer
						</Button>
					</HStack>
				)}
			</Box>
			{/* Upcoming */}
			<Box width={"100%"}>
				<Text fontSize={"20px"} fontWeight={600}>
					Kommande uppdrag
				</Text>
				<Divider mb={2} />
				{isLoading && <LoadingIndicator size={"s"} />}
				{!isLoading && (
					<VStack divider={<StackDivider borderColor="gray.200" />} gap={2}>
						{/* @ts-ignore */}
						{getJobList("upComing").map((job: any) => (
							<JobRow key={job.id} job={job} onClick={() => navigate(routes.jobById.replace(":id", job.id))} />
						))}
					</VStack>
				)}
				{/* @ts-ignore */}
				{!isLoading && jobData?.upComing?.length === 0 && (
					<Text fontSize={"16px"} m={0} fontWeight={400}>
						Inga resultat att visa
					</Text>
				)}
				{/* @ts-ignore */}
				{!isLoading && jobData?.upComing?.length > 0 && PAGE_SIZE * upComingPage < jobData?.upComing?.length && (
					<HStack justifyContent={"center"}>
						<Button
							onClick={() => setUpComingPage((prev) => prev + 1)}
							colorScheme="telegram"
							variant="outline"
							size="sm"
							my={5}
						>
							Visa mer
						</Button>
					</HStack>
				)}
			</Box>
			{/* Historical */}
			<Box width={"100%"}>
				<Text fontSize={"20px"} fontWeight={600}>
					Historiska uppdrag
				</Text>
				<Divider mb={2} />
				{isLoading && <LoadingIndicator size={"s"} />}
				{!isLoading && (
					<VStack divider={<StackDivider borderColor="gray.200" />} gap={2}>
						{/* @ts-ignore */}
						{getJobList("past").map((job: any) => (
							<JobRow key={job.id} job={job} onClick={() => navigate(routes.jobById.replace(":id", job.id))} />
						))}
					</VStack>
				)}
				{/* @ts-ignore */}
				{!isLoading && jobData?.past?.length === 0 && (
					<Text fontSize={"16px"} m={0} fontWeight={400}>
						Inga resultat att visa
					</Text>
				)}
				{/* @ts-ignore */}
				{!isLoading && jobData?.past?.length > 0 && PAGE_SIZE * pastPage < jobData?.past?.length && (
					<HStack justifyContent={"center"}>
						<Button
							onClick={() => setPastPage((prev) => prev + 1)}
							colorScheme="telegram"
							variant="outline"
							size="sm"
							my={5}
						>
							Visa mer
						</Button>
					</HStack>
				)}
			</Box>
		</>
	);
};

export default JobListData;
